var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "info-row" }, [
    _c("div", { staticClass: "info-row-left" }, [_vm._v(_vm._s(_vm.left))]),
    _c("div", { staticClass: "info-row-right" }, [_vm._v(_vm._s(_vm.right))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }